import React from "react";

function CapacityIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 13.3333C16.6128 13.3333 17.2197 13.2126 17.7859 12.9781C18.352 12.7436 18.8665 12.3998 19.2998 11.9665C19.7332 11.5332 20.0769 11.0187 20.3114 10.4525C20.546 9.88634 20.6667 9.2795 20.6667 8.66667C20.6667 8.05383 20.546 7.447 20.3114 6.88081C20.0769 6.31462 19.7332 5.80018 19.2998 5.36684C18.8665 4.9335 18.352 4.58975 17.7859 4.35523C17.2197 4.12071 16.6128 4 16 4C14.7623 4 13.5753 4.49167 12.7002 5.36684C11.825 6.24201 11.3333 7.42899 11.3333 8.66667C11.3333 9.90434 11.825 11.0913 12.7002 11.9665C13.5753 12.8417 14.7623 13.3333 16 13.3333ZM4 27.2V28H28V27.2C28 24.2133 28 22.72 27.4187 21.5787C26.9073 20.5752 26.0915 19.7593 25.088 19.248C23.9467 18.6667 22.4533 18.6667 19.4667 18.6667H12.5333C9.54667 18.6667 8.05333 18.6667 6.912 19.248C5.90851 19.7593 5.09265 20.5752 4.58133 21.5787C4 22.72 4 24.2133 4 27.2Z"
        stroke="#2D2020"
        strokeWidth="2"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default CapacityIcon;
